/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lot_Size_Stage_PurchaseInputs */

const vi_lot_size_stage_purchase = /** @type {(inputs: Lot_Size_Stage_PurchaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lô mua từ hộ`)
};

/**

* @param {Lot_Size_Stage_PurchaseInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const lot_size_stage_purchase = /** @type {((inputs?: Lot_Size_Stage_PurchaseInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lot_Size_Stage_PurchaseInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_lot_size_stage_purchase(inputs)
});